import styled from 'styled-components';

export const TermCellWrapper = styled.div`
`;
